import React, { Fragment, useEffect } from 'react'
import { useFormik } from 'formik'
import { Modal, Card } from 'react-bootstrap'
import { Button, Form } from 'react-bootstrap'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Auth,LoadingComponent } from 'recupero-comunes'
import AccionesLegalizacion from './AccionesLegalizacion'
import { configuracionFormAction9, obtenerCasoImplicado, obtenerDatosLlaves, PostRespuestaCobro } from '../../../store/actions/encargado-cia-action'
import AntededentesRecobroLegaliza from './AntededentesRecobroLegaliza'
import validationSchemasLegalizacion from '../../../common/validation-Schemas-Legalizacion'
import { obtenerForm10, PostLegalizarPago } from '../../../store/actions/legalizacion-pago-action'
import { useLocation, useNavigate } from 'react-router-dom'

const LegalizacionForms = () => {
  const [loading, setLoading]=useState(false)
  const dispatch = useDispatch()
  const {state}=useLocation()
  const idCasoLocation=state?.row?.IdCaso ? state.row.IdCaso:24
  const idImplicado=state?.row?.IdImplicado ? state.row.IdImplicado :1
  const idOrganizacionCaso =state?.row?.idOrganizacionCaso  ? state.row.idOrganizacionCaso:8600399880
  const queryState=state?.myQueryState && state.myQueryState
  const { rutUsuario, rutOrganizacion } = Auth.currentUser()
  const data_legalizacion =useSelector((state) => state.legalizacionPagoReducer)
  const { respuestaPostLegaliza}=data_legalizacion
  const data_encargado_cia = useSelector((state) => state.encargado_compania)
  const {antecedentesCasos, llaves} = data_encargado_cia
  const [periodo, setPeriodo] = useState('')
  const [idRGestion, setIdRGestion] = useState('')
  const [mtoPago, setMtopago] = useState('')
  const [nombreGirador, setNombreGirador] = useState('')
  const [idGiradorD, setIdGiradorD] = useState('')
  const [error,setError]=useState(false)
  const [show, setShow] = useState(false)
  const [actionButton, setActionButton] = useState("")
  const history =useNavigate()
  const handleClose = () => {
   
    if(respuestaPostLegaliza && respuestaPostLegaliza.respuestaPostLegaliza["code"]===-1){
      setShow(false)
    }else{
     
      history('/area-trabajo-recupero-companias',{state:{queryState}})
      setShow(false)
    }
  }
  useEffect(() => { 
    dispatch(obtenerDatosLlaves({"idCaso":idCasoLocation,"idImplicado":idImplicado,"idOrgCaso":idOrganizacionCaso}))
   
}, [dispatch])

useEffect(() => {
  if(llaves){
    setLoading(true)
    let query = Buffer.from(
      JSON.stringify({ idform: 10, rutcia: idOrganizacionCaso})
    ).toString('base64')
    dispatch(obtenerForm10(query))
    .then(()=>{
      let query = Buffer.from(
        JSON.stringify({ idform: 9, rutcia: idOrganizacionCaso})
      ).toString('base64')
      dispatch(configuracionFormAction9(query))
    })
    .then(()=>{
      let query = Buffer.from(JSON.stringify({ "idImplicado": llaves["idImplicado"], "idCaso": llaves["idCaso"] })).toString('base64');
      dispatch(obtenerCasoImplicado(query));
    })
    .then(()=>{
      setLoading(false)
    })
  }
}, [dispatch,llaves])

  const handleShow = () => setShow(true)

  const formik = useFormik({
    initialValues: {
      
      idCaso: '',
      idImplicadoCaso: '',
      idOrganizacion: '',
      numeroAviso: '',
      siniestro: '',
      fechaCaja: '',
      idRespGestion: '',
      monedaPago: '',
      montoPago: '',
      periodoContable: '',
      idGirador: '',
      nombreGirador: '',
      visar: '',
      idUsuario: ''
    },
    validationSchema: validationSchemasLegalizacion,

    onSubmit: (formData, formikHelpers) => {
      const data = { ...formData }
      if (actionButton==="procesar"){
        data['visar'] = 0
      }else{
        data['visar'] = 1

      }
      data['idCaso'] = llaves && llaves['idCaso']
      data['idImplicadoCaso'] = llaves && llaves['idImplicado']
      data['idOrganizacion'] = llaves && llaves['idOrgCaso']
      data['idUsuario'] =rutUsuario && rutUsuario
      data['periodoContable'] = periodo && periodo
      data['montoPago'] = mtoPago && mtoPago
      data['nombreGirador'] = nombreGirador && nombreGirador
      const idGira=idGiradorD && idGiradorD.substring(0, idGiradorD.length - 1)
      data['idGirador'] = idGira
     
      data['siniestro'] = antecedentesCasos && antecedentesCasos?.antecedentesCasos[0]['Siniestro']
     
      const idgestion =
        idRGestion && idRGestion.substring(0, idRGestion.length - 1)
      data['idRespGestion'] = idgestion
     
      dispatch(PostLegalizarPago(data))    
     
      handleShow()
     

     
    }
  })
  return (
    <>
      <LoadingComponent show={loading}/>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Respuesta de la información enviada</Modal.Title>
        </Modal.Header>
        <Modal.Body>
      { respuestaPostLegaliza ? respuestaPostLegaliza.respuestaPostLegaliza["message"]:"Enviando..."} 
        </Modal.Body>
        {respuestaPostLegaliza && <Modal.Footer>
          <Button variant='primary' onClick={handleClose}>
            Aceptar
          </Button>
        </Modal.Footer>}
      </Modal>
      <Card>
        <Form onSubmit={formik.handleSubmit}>
          <Card.Body>
            {/*<AntecendentesImplicado formik={formik} />*/}
            <AntededentesRecobroLegaliza formik={formik} />
            {/*<PagoRecepcionadoCia
              error={error}
              formik={formik}
              setPeriodo={setPeriodo}
              setIdRGestion={setIdRGestion}
              setMtopago={setMtopago}
              setNombreGirador={setNombreGirador}
              setIdGiradorD={setIdGiradorD}
            />*/}
          </Card.Body>  
          <Card.Footer style={{ display: 'flex', justifyContent: 'right' }}>
            <AccionesLegalizacion formik={formik} 
              setError={setError}
              periodo={periodo}
              idRGestion={idRGestion}
              mtoPago={mtoPago}
              nombreGirador={nombreGirador}
              idGiradorD={idGiradorD}
              setActionButton={setActionButton}
            />
          </Card.Footer>
        </Form>
      </Card>
    </>
  )
}

export default LegalizacionForms
